import React from 'react';
import { Container } from 'reactstrap';
import { StaticQuery, graphql } from 'gatsby';

import SEO from './shared/seo';

import { ProductCardsComponent } from '../templates/product/ProductCardsComponent';

const Store = ({
  products, title, description, seoActivated,
}) => (
  <>
    {seoActivated && (
      <SEO
        title={title[0].toUpperCase() + title.substring(1)}
        keywords={['locevent', 'essonne', '91', 'location', 'materiel', 'reception', 'mariage', title]}
      />
    )}
    <Container style={{ margin: '1em auto' }}>
      <div className="text-center">
        <h2 className="with-underline">
          {title}
        </h2>
      </div>
      <div className="text-center">
        <div
          dangerouslySetInnerHTML={{
            __html: description.childMarkdownRemark.html,
          }}
        />
      </div>
      <ProductCardsComponent
        products={products}
        large={3}
        medium={6}
      />
    </Container>
  </>
);

export const query = graphql`
  query CategoryStore {
    allContentfulCategory {
      edges {
        node {
          id
          title {
            title
          }
          description {
            childMarkdownRemark {
              html
            }
          }
          product {
            id
            name
            id
            name
            slug
            rating
            price
            conditionnement
            categories {
              title {
                title
              }
              slug
              description {
                childMarkdownRemark {
                  html
                }
              }
            }
            image {
              fixed(width: 1000, height: 500) {
                width
                height
                src
                srcSet
              }
              file {
                url
              }
            }
            details {
              childMarkdownRemark {
                excerpt(pruneLength: 140)
              }
            }
            declinaisons {
              name
              value
              price
              type
              images {
                id
                file {
                  url
                }
              }
            }
          }
        }
      }
    }
  }
`;

const Wrapper = (props) => (
  <StaticQuery
    query={query}
    render={(data) => {
      const filteredCategory = data.allContentfulCategory.edges.filter(
        (category) => category.node.title.title === props.title,
      );
      // filtered and limited products
      const products = filteredCategory[0].node.product.slice(0, props.limit);
      return (
        <Store
          products={products}
          title={props.displayTitle || filteredCategory[0].node.title.title}
          description={filteredCategory[0].node.description}
          seoActivated={props.seoActivated}
          context={props}
        />
      );
    }}
  />
);

export default Wrapper;
